<template>
    <div class="w-full relative border-gray-300 border-b">

        <template v-if="! [4, 5].includes(auction.md)">
            <video v-for="stream in auction.ms"
                @click="switchVideo"
                :ref="`videoPlayer_${stream.stream_name}`"
                :id="`videoPlayer_${stream.stream_name}`"
                class="object-fill w-full"
                :class="{
                    'video-main': show == 'video', 
                    'video-secondary': show == 'image', 
                    'visible': auction.cs == stream.name || (auction.cs == 'local' && stream.locale == locale), 
                    'hidden': (auction.cs != 'local' && auction.cs != stream.name) || (auction.cs == 'local' && stream.locale != locale), 
                }"
                :poster="`/images/live-${locale}.png`"
                autoplay 
                loop 
                muted 
                controls
                playsinline>
            </video>

            <div @click="switchVideo" :class="{'image-main': show == 'image', 'image-secondary': show == 'video'}" class="z-20 lot-image-mobile flex flex-1 flex-col items-start justify-start p-2 bg-color-white">
                <transition name="fade" mode="out-in">
                    <img :key="lot.id" :src="lot.img" />
                </transition>
                <img v-if="nextLot" :src="nextLot.img" width="1" height="1" class="opacity-0">
            </div>
        </template>

        <div v-else class="image-main z-20 lot-image-mobile flex flex-1 flex-col items-center justify-center p-2 bg-color-white">
            <transition name="fade" mode="out-in">
                <img :key="lot.id" :src="lot.img" />
            </transition>
            <img v-if="nextLot" :src="nextLot.img" width="1" height="1" class="opacity-0">
        </div>
        <div v-if="muted && ![4, 5].includes(auction.md)" class="absolute flex justify-center items-center inset-0" style="background: rgba(0, 0, 0, .25); color: #ffffff;">
            <button @click="toggleMute" class="flex flex-col items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                </svg>
                {{ $t('general.turn_on_sound') }}
            </button>
        </div>
        <div v-else class="text-xs absolute flex justify-center items-center left-0 top-0 p-2 text-white">
            <button @click="toggleMute" class="text-xs flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                </svg>
                {{ $t('general.turn_off_sound') }}
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import AnimatedNumber from '../global/AnimatedNumber'
import Paddle from '../global/Paddle'
import { Constants } from '../../constants'
import WowzaWebRTCPlay from '../../lib/wowza/WowzaWebRTCPlay.js'

var webRTCAdaptor = [];
var autoRepublishIntervalJob = [];

export default {
    components: {
        AnimatedNumber, Paddle
    },
    data () {
        return {
            ...Constants,
            muted: true,
            showVideoOptions: false,
            show: 'video',
            state: '',
        }
    },
    computed: {
        ...mapGetters({
            currency: 'getCurrency',
            locale: 'getLocale',
            user: 'getUser',
            auction: 'getAuction',
            lot: 'getLot',
            nextLot: 'getNextLot',
            bids: 'getBids',
            winner: 'getWinner',
            isHighestBidder: 'getIsHighestBidder',
            isWinner: 'getIsWinner',
            isBidder: 'getIsBidder',
        }),
        canBid () {
            if(this.lot.s != this.LOT_AUCTION_STATUS_OPEN) return false
            if(!this.user) return false
            if(this.winner && this.winner.uid == this.user.id) return false
            if(this.bids.filter(el => el.uid == this.user.id).length > 0) return false
            return true
        },
    },
    watch: {
        'auction.cs': function(oa, na) {
            if(oa != na) {
                this.unmuteAll();
            }
        }
    },
    methods: {
        switchVideo () {
            if(this.show == 'video') {
                this.show = 'image'
            } else {
                this.show = 'video'
            }
        },
        toggleMute () {
            this.muted = ! this.muted
            ding.mute(this.muted)
            outbid.mute(this.muted)
            highest.mute(this.muted)
            congrats.mute(this.muted)

            Vue.nextTick(() => {
                this.auction.ms.forEach(stream => {
                    if(this.auction.cs == 'local') {
                        if(stream.locale == this.locale) { // daca este local pornim audio doar streamului local
                            this.$refs['videoPlayer_' + stream.stream_name][0].muted = this.muted;
                        } else { // il tinem in continuare muted orice ar fi
                            this.$refs['videoPlayer_' + stream.stream_name][0].muted = true;
                        }
                    } else {
                        this.$refs['videoPlayer_' + stream.stream_name][0].muted = this.muted;
                    }
                })
            })
        },
        unmuteAll() {
            Vue.nextTick(() => {
                this.auction.ms.forEach(stream => {
                    if(this.auction.cs == 'local') {
                        if(stream.locale == this.locale) { // daca este local pornim audio doar streamului local
                            this.$refs['videoPlayer_' + stream.stream_name][0].muted = this.muted;
                        } else { // il tinem in continuare muted orice ar fi
                            this.$refs['videoPlayer_' + stream.stream_name][0].muted = true;
                        }
                    } else {
                        this.$refs['videoPlayer_' + stream.stream_name][0].muted = this.muted;
                    }
                    this.$refs['videoPlayer_' + stream.stream_name][0].play();
                })
            })
        },
        async bid() {
            this.$notify({
                title: 'Hello user!',
                text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                type: 'error',
            })
            this.isBidding = true
            const bid = await this.$store.dispatch('sendBid', {
                auction_id: this.auction.id,
                lot_id: this.lot.id,
                amount: this.lot.k
            })
            this.isBidding = false
        },
        setupWowzaStream(stream) {

            webRTCAdaptor[stream] = new WowzaWebRTCPlay();

            webRTCAdaptor[stream].on({
                onError: this.errorHandler.bind(null, stream),
                onStateChanged: this.stateChangedHandler.bind(null, stream),
            });

            webRTCAdaptor[stream].set({
                videoElementPlay: this.$refs['videoPlayer_' + stream][0],
                sdpURL: 'wss://streaming2.artmark.ro/webrtc-session.json',
                applicationName: 'webrtc',
                streamName: 'artmark-' + stream,
            }).then(() => {
                this.start(stream);
            });
        },
        retryConnection (stream) {
            if (autoRepublishIntervalJob[stream] == undefined || autoRepublishIntervalJob[stream] == null) {
                autoRepublishIntervalJob[stream] = setInterval(() => {
                    this.start(stream)
                }, 5000)
            }
        },
        cancelReconnection(stream) {
            if (autoRepublishIntervalJob[stream] != null) {
                clearInterval(autoRepublishIntervalJob[stream])
                autoRepublishIntervalJob[stream] = null;
            }
        },
        start(stream) {
            if(webRTCAdaptor[stream]) {
                webRTCAdaptor[stream].play();
            }
        },
        stop(stream) {
            try {
                webRTCAdaptor[stream].stop();
            } catch (error) {
                console.log(error)
            }
            this.cancelReconnection(stream);
        },
        errorHandler(error) {
            console.log(error);
            this.retryConnection()
        },
        stateChangedHandler(stream, state) {
            if (state.connectionState == 'connecting') {
                this.cancelReconnection(stream)
            } else if (state.connectionState == 'connected') {
                this.cancelReconnection(stream)
            } else if (state.connectionState == 'disconnected') {
                this.retryConnection(stream)
            } else if (state.connectionState == 'failed') {
                this.retryConnection(stream)
            } else if (state.connectionState == 'stopped') {
                this.retryConnection(stream)
            } else {
                //
            }
        },
    },
    mounted () {
        this.videoVolume = parseInt(localStorage.getItem('videoVolume')) || 50;
        this.soundsVolume = parseInt(localStorage.getItem('soundsVolume')) || 25;

        this.auction.ms.forEach(stream => {
            this.cancelReconnection(stream.stream_name);
            this.setupWowzaStream(stream.stream_name);
        });
    },
}
</script>
